var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowserEdgeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_2123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8316 26.7891C32.3489 27.0399 31.8511 27.2607 31.341 27.45C29.726 28.0511 28.0158 28.356 26.2926 28.35C19.641 28.35 13.8473 23.7797 13.8473 17.9016C13.8559 17.1145 14.0741 16.3439 14.4795 15.6691C14.8848 14.9943 15.4627 14.4398 16.1535 14.0625C10.1348 14.3156 8.58789 20.5875 8.58789 24.2578C8.58789 34.6641 18.1645 35.7047 20.2316 35.7047C21.3426 35.7047 23.016 35.3813 24.0285 35.0578L24.2113 35.0016C28.0861 33.6625 31.3893 31.0437 33.577 27.5766C33.6405 27.4712 33.6678 27.3479 33.6546 27.2256C33.6414 27.1033 33.5885 26.9886 33.5039 26.8993C33.4193 26.8099 33.3078 26.7507 33.1863 26.7308C33.0649 26.7109 32.9403 26.7314 32.8316 26.7891Z",
    fill: "url(#paint0_linear_88_2123)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.8316 26.7891C32.3489 27.0399 31.8511 27.2607 31.341 27.45C29.726 28.0511 28.0158 28.356 26.2926 28.35C19.641 28.35 13.8473 23.7797 13.8473 17.9016C13.8559 17.1145 14.0741 16.3439 14.4795 15.6691C14.8848 14.9943 15.4627 14.4398 16.1535 14.0625C10.1348 14.3156 8.58789 20.5875 8.58789 24.2578C8.58789 34.6641 18.1645 35.7047 20.2316 35.7047C21.3426 35.7047 23.016 35.3813 24.0285 35.0578L24.2113 35.0016C28.0861 33.6625 31.3893 31.0437 33.577 27.5766C33.6405 27.4712 33.6678 27.3479 33.6546 27.2256C33.6414 27.1033 33.5885 26.9886 33.5039 26.8993C33.4193 26.8099 33.3078 26.7507 33.1863 26.7308C33.0649 26.7109 32.9403 26.7314 32.8316 26.7891Z",
    fill: "url(#paint1_radial_88_2123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1974 33.9329C13.9457 33.1555 12.8607 32.1374 12.0052 30.9376C11.0284 29.6005 10.3559 28.0659 10.0352 26.4413C9.71437 24.8168 9.75298 23.1417 10.1483 21.5337C10.5436 19.9257 11.286 18.4236 12.3235 17.133C13.3609 15.8423 14.6682 14.7944 16.1537 14.0626C16.6037 13.8517 17.349 13.486 18.3474 13.5001C19.05 13.5055 19.7418 13.6734 20.3688 13.9905C20.9957 14.3076 21.5408 14.7655 21.9615 15.3282C22.5273 16.0891 22.8375 17.0097 22.8474 17.9579C22.8474 17.9298 26.2927 6.76416 11.5974 6.76416C5.42399 6.76416 0.347427 12.6142 0.347427 17.761C0.322871 20.4798 0.90413 23.1699 2.04899 25.636C3.9239 29.6284 7.19943 32.7934 11.2538 34.5303C15.3081 36.2671 19.8591 36.4549 24.0427 35.0579C22.577 35.5208 21.0283 35.66 19.5035 35.4657C17.9787 35.2715 16.5143 34.7485 15.2115 33.9329H15.1974Z",
    fill: "url(#paint2_linear_88_2123)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M15.1974 33.9329C13.9457 33.1555 12.8607 32.1374 12.0052 30.9376C11.0284 29.6005 10.3559 28.0659 10.0352 26.4413C9.71437 24.8168 9.75298 23.1417 10.1483 21.5337C10.5436 19.9257 11.286 18.4236 12.3235 17.133C13.3609 15.8423 14.6682 14.7944 16.1537 14.0626C16.6037 13.8517 17.349 13.486 18.3474 13.5001C19.05 13.5055 19.7418 13.6734 20.3688 13.9905C20.9957 14.3076 21.5408 14.7655 21.9615 15.3282C22.5273 16.0891 22.8375 17.0097 22.8474 17.9579C22.8474 17.9298 26.2927 6.76416 11.5974 6.76416C5.42399 6.76416 0.347427 12.6142 0.347427 17.761C0.322871 20.4798 0.90413 23.1699 2.04899 25.636C3.9239 29.6284 7.19943 32.7934 11.2538 34.5303C15.3081 36.2671 19.8591 36.4549 24.0427 35.0579C22.577 35.5208 21.0283 35.66 19.5035 35.4657C17.9787 35.2715 16.5143 34.7485 15.2115 33.9329H15.1974Z",
    fill: "url(#paint3_radial_88_2123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7645 20.925C21.6379 21.0656 21.2864 21.2766 21.2864 21.7125C21.2864 22.0781 21.5254 22.4438 21.9614 22.7391C23.9723 24.1453 27.7833 23.9484 27.7973 23.9484C29.2965 23.9475 30.7679 23.5444 32.0583 22.7812C33.3573 22.0214 34.4353 20.9352 35.1852 19.6303C35.935 18.3254 36.3308 16.8472 36.3333 15.3422C36.3754 12.1922 35.2083 10.0969 34.7442 9.16875C31.7489 3.34687 25.3223 8.81216e-08 18.3333 8.81216e-08C13.6029 -0.000467658 9.06247 1.86117 5.69399 5.18227C2.32552 8.50338 0.399773 13.017 0.333252 17.7469C0.403564 12.6141 5.50825 8.46562 11.5833 8.46562C12.0754 8.46562 14.8879 8.50781 17.4895 9.87187C19.3172 10.7801 20.8308 12.2153 21.8348 13.9922C22.6926 15.4828 22.8473 17.3813 22.8473 18.1406C22.8473 18.9 22.4676 20.0109 21.7504 20.9391L21.7645 20.925Z",
    fill: "url(#paint4_radial_88_2123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7645 20.925C21.6379 21.0656 21.2864 21.2766 21.2864 21.7125C21.2864 22.0781 21.5254 22.4438 21.9614 22.7391C23.9723 24.1453 27.7833 23.9484 27.7973 23.9484C29.2965 23.9475 30.7679 23.5444 32.0583 22.7812C33.3573 22.0214 34.4353 20.9352 35.1852 19.6303C35.935 18.3254 36.3308 16.8472 36.3333 15.3422C36.3754 12.1922 35.2083 10.0969 34.7442 9.16875C31.7489 3.34687 25.3223 8.81216e-08 18.3333 8.81216e-08C13.6029 -0.000467658 9.06247 1.86117 5.69399 5.18227C2.32552 8.50338 0.399773 13.017 0.333252 17.7469C0.403564 12.6141 5.50825 8.46562 11.5833 8.46562C12.0754 8.46562 14.8879 8.50781 17.4895 9.87187C19.3172 10.7801 20.8308 12.2153 21.8348 13.9922C22.6926 15.4828 22.8473 17.3813 22.8473 18.1406C22.8473 18.9 22.4676 20.0109 21.7504 20.9391L21.7645 20.925Z",
    fill: "url(#paint5_radial_88_2123)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_88_2123",
    x1: 8.58789,
    y1: 24.8906,
    x2: 33.6754,
    y2: 24.8906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_88_2123",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.4395 25.0798) scale(13.4156 12.7448)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_88_2123",
    x1: 21.8068,
    y1: 14.0063,
    x2: 6.15524,
    y2: 31.0642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_88_2123",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.02062 -19.9361 -16.11 -2.4165 10.2552 27.9756)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_88_2123",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.1385 28.4625 60.6251 2.277 3.97403 6.65381)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_88_2123",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.83119 13.1355 10.6726 -3.14705 34.0917 10.8703)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66EB6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_2123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.333252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserEdgeIcon);
export default __webpack_public_path__ + "static/media/browser_EdgeIcon.a6b9a113594c882a981e55311c39eef9.svg";
export { ForwardRef as ReactComponent };